export default __webpack_public_path__ + "static/media/5eb611b0e73cbac3.7ce4fd7643118141b43d1db06335a5d6.svg";